import { Moment } from 'moment';

import { ItemActionBase } from 'app/buffer-graph/models/item-actions/item-action-base';
import { FreshItemActionLine } from 'app/buffer-graph/models/item-actions/fresh-item-action-line';

export class FreshItemActionHeader extends ItemActionBase {
    constructor(
        id: string,
        actionSeason: string,
        status: string,
        note: string,
        purchaseDate: string,
        startDate: string,
        arriveDate: string,
        endDate: string,
        saleChangeRatio: string/*number*/,
        saleIncrease: string/*number*/,
        replenishment: string,
        actionOut: string,
        importDate: string,
        documentNumber: string,
        cancelAction: string,
        purchaseType: string,
        prevActionAvgSale : string,
        prevActionPeriod : string,
        prevActionDocumentNumber : string,
        addAdditionalStock : number,
        public readonly lines: FreshItemActionLine[]) {
        super(id,
            actionSeason,
            status,
            note,
            purchaseDate,
            startDate,
            arriveDate,
            endDate,
            saleChangeRatio,
            saleIncrease,
            replenishment,
            actionOut,
            importDate,
            documentNumber,
            cancelAction,
            purchaseType,
            prevActionAvgSale,
            prevActionPeriod,
            prevActionDocumentNumber,
            addAdditionalStock);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/fresh-item-action-header.ts